export enum LEAD_SOURCE {
  CONTACT_US = 'CONTACT_US',
  FREE_CONSULTATION = 'FREE_CONSULTATION',
}

export enum ActivityType {
  CONSULTATION_REQUESTED = 'CONSULTATION_REQUESTED',
  CONTACTED_US = 'CONTACTED_US',
}

export enum ReasonEnum {
  REUNITE_WITH_FAMILY = 'REUNITE_WITH_FAMILY',
  WORK_FOR_OWN_COMPANY = 'WORK_FOR_OWN_COMPANY',
  RELOCATING_FOR_CURRENT_JOB = 'RELOCATING_FOR_CURRENT_JOB',
  INVEST_IN_US_BUSINESS = 'INVEST_IN_US_BUSINESS',
  STUDY_OR_VISIT = 'STUDY_OR_VISIT',
  OTHER = 'OTHER',
}

export type I18nSupport = {
  i18nPrefix: string;
};
